import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { ClubEditorPage } from '#src/pages/profile/ClubEditor/index.tsx';

const EditPage = () => <ClubEditorPage sport={Sport.FOOTBALL} />;

export default EditPage;
